import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "photo-board" }
const _hoisted_2 = { class: "board-shell" }
const _hoisted_3 = { class: "toolbar" }
const _hoisted_4 = { class: "patient-picker" }
const _hoisted_5 = {
  key: 0,
  class: "patient-results"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "file-button" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "summary-grid" }
const _hoisted_10 = { class: "content-grid" }
const _hoisted_11 = { class: "thumb-panel" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "viewer-panel" }
const _hoisted_16 = { class: "viewer" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 1 }

import { computed, ref, watch } from 'vue';

type Patient = { id?: number; chartNo: string; name: string; phone?: string };
type BoardImage = { id: number; chartNo: string; patientName: string; name: string; url: string; date: string; memo: string };

const STORAGE_KEY = 'bioa-counsel-photos';

export default /*@__PURE__*/_defineComponent({
  __name: 'MonitorPage',
  setup(__props) {

const patients = ref<Patient[]>(loadPatients());
const images = ref<BoardImage[]>(readStorage<BoardImage[]>(STORAGE_KEY, []));
const currentPatient = ref<Patient | null>(patients.value[0] || null);
const patientQuery = ref(currentPatient.value ? `${currentPatient.value.name} ${currentPatient.value.chartNo}` : '');
const patientListOpen = ref(false);
const selectedImageId = ref<number | null>(null);
const memo = ref('');

const filteredPatients = computed(() => {
  const q = patientQuery.value.trim().toLowerCase();
  return patients.value.filter((p) => [p.name, p.chartNo, p.phone].join(' ').toLowerCase().includes(q)).slice(0, 40);
});
const currentImages = computed(() => images.value.filter((image) => !currentPatient.value || image.chartNo === currentPatient.value.chartNo).sort((a, b) => b.id - a.id));
const selectedImage = computed(() => currentImages.value.find((image) => image.id === selectedImageId.value) || currentImages.value[0] || null);

watch(selectedImage, (image) => {
  if (image) {
    selectedImageId.value = image.id;
    memo.value = image.memo || '';
  } else {
    memo.value = '';
  }
}, { immediate: true });

function selectPatient(patient: Patient) {
  currentPatient.value = patient;
  patientQuery.value = `${patient.name} ${patient.chartNo}`;
  patientListOpen.value = false;
  selectedImageId.value = null;
}

function pickImages(event: Event) {
  if (!currentPatient.value) return alert('환자를 선택하세요.');
  const input = event.target as HTMLInputElement;
  Array.from(input.files || []).forEach((file) => {
    const reader = new FileReader();
    reader.onload = () => {
      images.value.push({
        id: Date.now() + Math.random(),
        chartNo: currentPatient.value?.chartNo || '',
        patientName: currentPatient.value?.name || '',
        name: file.name,
        url: String(reader.result || ''),
        date: today(),
        memo: '',
      });
      persist();
    };
    reader.readAsDataURL(file);
  });
  input.value = '';
}

function saveBoard() {
  if (!selectedImage.value) return;
  const index = images.value.findIndex((image) => image.id === selectedImage.value?.id);
  if (index >= 0) {
    images.value[index] = { ...images.value[index], memo: memo.value };
    persist();
    alert('상담보드 사진 메모가 저장되었습니다.');
  }
}

function deleteSelected() {
  if (!selectedImage.value || !window.confirm('선택한 사진을 삭제할까요?')) return;
  images.value = images.value.filter((image) => image.id !== selectedImage.value?.id);
  selectedImageId.value = null;
  persist();
}

function persist() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(images.value));
}

function loadPatients(): Patient[] {
  const stored = readStorage<Patient[]>('bioa-patients', []);
  if (stored.length) return stored.map((p) => ({ chartNo: p.chartNo || `P-${p.id || 'TEMP'}`, name: p.name || '환자', phone: p.phone || '' }));
  return [];
}

function readStorage<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) as T : fallback;
  } catch {
    return fallback;
  }
}

function today() {
  return new Date().toISOString().slice(0, 10);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("nav", { class: "tabs" }, [
        _createElementVNode("button", { class: "active" }, "상담 보드 사진")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "환자", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((patientQuery).value = $event)),
            placeholder: "이름/차트/전화 검색",
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (patientListOpen.value = true))
          }, null, 544), [
            [_vModelText, patientQuery.value]
          ]),
          (patientListOpen.value && patientQuery.value.trim())
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPatients.value, (patient) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: patient.chartNo,
                    type: "button",
                    onClick: ($event: any) => (selectPatient(patient))
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(patient.name), 1),
                    _createElementVNode("span", null, _toDisplayString(patient.chartNo) + " · " + _toDisplayString(patient.phone || '-'), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("label", _hoisted_7, [
          _cache[4] || (_cache[4] = _createTextVNode(" 사진 추가 ")),
          _createElementVNode("input", {
            type: "file",
            multiple: "",
            accept: "image/*",
            onChange: pickImages
          }, null, 32)
        ]),
        _createElementVNode("button", {
          disabled: !selectedImage.value,
          onClick: deleteSelected
        }, "삭제", 8, _hoisted_8),
        _createElementVNode("button", { onClick: saveBoard }, "저장")
      ]),
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("article", null, [
          _cache[5] || (_cache[5] = _createElementVNode("span", null, "환자", -1)),
          _createElementVNode("strong", null, _toDisplayString(currentPatient.value?.name || '미선택'), 1)
        ]),
        _createElementVNode("article", null, [
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "차트번호", -1)),
          _createElementVNode("strong", null, _toDisplayString(currentPatient.value?.chartNo || '-'), 1)
        ]),
        _createElementVNode("article", null, [
          _cache[7] || (_cache[7] = _createElementVNode("span", null, "사진", -1)),
          _createElementVNode("strong", null, _toDisplayString(currentImages.value.length) + "장", 1)
        ]),
        _createElementVNode("article", null, [
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "선택", -1)),
          _createElementVNode("strong", null, _toDisplayString(selectedImage.value?.name || '-'), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_10, [
        _createElementVNode("aside", _hoisted_11, [
          _cache[9] || (_cache[9] = _createElementVNode("header", null, "환자 사진 목록", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentImages.value, (image) => {
            return (_openBlock(), _createElementBlock("button", {
              key: image.id,
              type: "button",
              class: _normalizeClass({ selected: selectedImageId.value === image.id }),
              onClick: ($event: any) => (selectedImageId.value = image.id)
            }, [
              _createElementVNode("img", {
                src: image.url,
                alt: ""
              }, null, 8, _hoisted_13),
              _createElementVNode("span", null, _toDisplayString(image.name), 1)
            ], 10, _hoisted_12))
          }), 128)),
          (!currentImages.value.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, "사진을 추가하세요."))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("section", _hoisted_15, [
          _createElementVNode("header", null, [
            _createElementVNode("strong", null, _toDisplayString(selectedImage.value?.name || '사진 선택'), 1),
            _createElementVNode("span", null, _toDisplayString(selectedImage.value?.date || ''), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            (selectedImage.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: selectedImage.value.url,
                  alt: "상담 사진"
                }, null, 8, _hoisted_17))
              : (_openBlock(), _createElementBlock("p", _hoisted_18, "왼쪽에서 사진을 선택하세요."))
          ]),
          _createElementVNode("footer", null, [
            _createElementVNode("label", null, [
              _cache[10] || (_cache[10] = _createElementVNode("span", null, "상담 메모", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((memo).value = $event)),
                rows: "3",
                placeholder: "사진 상담 내용, 설명 메모"
              }, null, 512), [
                [_vModelText, memo.value]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})